/**
 * 工具类
 */
 import Vue from 'vue'
 import CryptoJS from 'crypto-js'
 export default {//加密
   encrypt(word, keyStr){ 
     keyStr = keyStr ? keyStr : 'abcd1234abcd1234';
     var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
     var srcs = CryptoJS.enc.Utf8.parse(word);
     var encrypted = CryptoJS.AES.encrypt(srcs, key, {iv:'abcdefgabcdefg12',mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
     return encrypted.toString();
   },
   //解密.
   decrypt(word, keyStr){  
     keyStr = keyStr ? keyStr : 'abcd1234abcd1234';
     var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
     var decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
     return CryptoJS.enc.Utf8.stringify(decrypt).toString();
   }
 
 }
// import CryptoJS from 'crypto-js/crypto-js'

// // 默认的 KEY 与 iv 如果没有给
// const KEY = CryptoJS.enc.Utf8.parse("abcdefgabcdefg12");
// const IV = CryptoJS.enc.Utf8.parse('abcdefgabcdefg12');
// /**
//  * AES加密 ：字符串 key iv  返回base64 
//  */
// export function Encrypt(word, keyStr, ivStr) {
//   let key = KEY
//   let iv = IV

//   if (keyStr) {
//     key = CryptoJS.enc.Utf8.parse(keyStr);
//     iv = CryptoJS.enc.Utf8.parse(ivStr);
//   }

//   let srcs = CryptoJS.enc.Utf8.parse(word);
//   var encrypted = CryptoJS.AES.encrypt(srcs, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.ZeroPadding
//   });
//  // console.log("-=-=-=-", encrypted.ciphertext)
//   return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);

// }
// /**
//  * AES 解密 ：字符串 key iv  返回base64 
//  *
//  */
// export function Decrypt(word, keyStr, ivStr) {
//   let key  = KEY
//   let iv = IV

//   if (keyStr) {
//     key = CryptoJS.enc.Utf8.parse(keyStr);
//     iv = CryptoJS.enc.Utf8.parse(ivStr);
//   }

//   let base64 = CryptoJS.enc.Base64.parse(word);
//   let src = CryptoJS.enc.Base64.stringify(base64);

//   var decrypt = CryptoJS.AES.decrypt(src, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.ZeroPadding
//   });

//   var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
//   return decryptedStr.toString();
// }
